import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge, Modal } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteDriverData, getDriverList, logoutDriverDevice, updateDriverData, resetDriverRegistrationStatus, uploadDriverPhoto, updateDriverStatusData } from "../../redux/actions/DriverActions";
import apiClient from "../../axios/apiClient";
import RoundedPagination from "../../Components/Paginate";
import FormInput from "../../Components/FormInput";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";
import Preloader from "../../Components/Preloader";
import Status from "../../enums/Status";




const Dashboard = () => {
  const { t } = useTranslation();
  const tableRef = useRef();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [selectedPhotoUrl, setSelectedPhotoUrl] = useState(null);
  const [showPhotoUploadModal, setShowPhotoUploadModal] = useState(false);
  const [file,setFile]=useState(null);
  const [photoUploadDriverId, setPhotoUploadDriverId] = useState(null);
  const [pictureurl,setpictureurl]=useState(null);
  const navigate = useNavigate();
  const {
    AuthReducer: { auth, errors, loading },
    driverReducer: {
      driverLists,
      driverPermissions,
      loadingDriver,
      errorsDriver,
      driverCount,
      changedDriverStatus,
      changedDriverRegistration,
      changedDriverPhoto,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const photoInputRef = useRef(null);
  // const [photoUploadDriverId, setPhotoUploadDriverId] = useState(null);
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  // useEffect(() => {
  //   dispatch(getDriverList(auth?.accessToken, paginate, page, search, sort));
  // }, [auth, paginate, page, search, sort]);

  const fetchDriverList = useCallback(() => {
    if (auth?.accessToken) {
      dispatch(getDriverList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchDriverList, 500, [auth, paginate, page, search, sort]);

  useEffect(() => {
    if (errors) {
      if (errors?.status == 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors])



  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? driverCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteDriverData(auth?.accessToken, id))
        }
      });
  };

  const handleStatusChangeRequest = (item, newStatus) => {
    swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${newStatus}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateDriverData(auth?.accessToken, 
          {
              driverId: item?.driverId,
          driverName: item?.driverName,
          mobileNumber: item?.mobileNumber,
          address: item?.address,
          dlNumber: item?.dlNumber,
          password: item?.password,
          aadhaarNumber: item?.aadhaarNumber,
          dlExpiry: item?.dlExpiry,
          vehicleId: item?.vehicle?.id,
          vendorId: item?.vendor?.id,
          jenId: item?.jen?.id ,
          cityCode: item?.city?.nicCityCode,
          stateCode: item?.state?.nicStateCode,
          status: newStatus,
          photo:file,
          },item?.id, ));
      }
    });
  };

  const handleResetRegistrationRequest = (item, newStatus) => {
    swal.fire({
      title: "Reset Registration?",
          text: `Driver "${item?.driverName}" registration status will be changed to inactive.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, reset it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(resetDriverRegistrationStatus(auth?.accessToken, 
          item?.id, newStatus));
      }
    });
  };

  useEffect(() => {
    if (changedDriverStatus?.message){
      swal.fire({
        show: true,
        // title: "Deleted!",
        text: changedDriverStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_DRIVER_STATUS' });
      dispatch(getDriverList(auth?.accessToken, paginate, page, search, sort));
    }
    else if (changedDriverStatus.message){
      swal.fire({
        show: true,
        title: "Great !",
        text: changedDriverStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_DRIVER_STATUS' });
      dispatch(getDriverList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [changedDriverStatus])

    
    useEffect(() => {
      if (changedDriverPhoto?.message) {
        swal.fire({
          show: true,
          text: changedDriverPhoto?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        dispatch(getDriverList(auth?.accessToken, paginate, page, search, sort));
      }
    }, [changedDriverPhoto, dispatch, auth?.accessToken, paginate, page, search, sort]);

  useEffect(() => {
    if (changedDriverRegistration?.message) {
      swal.fire({
        show: true,
        text: changedDriverRegistration?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch(getDriverList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [changedDriverRegistration,dispatch, auth?.accessToken, paginate, page, search, sort]);

  const handleOpenPhotoModal = (photoUrl) => {
    if (!photoUrl) return;
    setSelectedPhotoUrl(photoUrl);
    setShowPhotoModal(true);
  };

  const handleClosePhotoModal = () => {
    setShowPhotoModal(false);
    setSelectedPhotoUrl(null);
  };

const handleOpenPhotoUploadModal = (id) => {
  setShowPhotoUploadModal(true);
  setPhotoUploadDriverId(id);
  photoInputRef.current?.click();
};
const handleClosePhotoUploadModal = () => {
  setShowPhotoUploadModal(false);
  setPhotoUploadDriverId(null);
  setpictureurl(null);
  setFile(null);
};
const handlePhotoFileChange = (e) => {
  const file = e.target.files?.[0];
  console.log("file", file);


  if (!file) {
    setpictureurl(null);
    setFile(null);
    return;
  }

  setpictureurl(URL.createObjectURL(file));
  setFile(file);
  // console.log("pictureurl", pictureurl);

  if (!photoUploadDriverId) return;
};
useEffect(() => {
  console.log("pictureurl",pictureurl);
}, [pictureurl]);

const handlePhotoUploadClick = () => {
  
  if (!file) {
    toast.error("Please select a photo first");
    return;
  } 
  dispatch(uploadDriverPhoto(auth?.accessToken, photoUploadDriverId, file));
  setShowPhotoUploadModal(false);
  setpictureurl(null);
  setFile(null);
}
  const driverLogout = (id, imeiDriversUsers) => {
    swal.fire({
      title: "Are you sure?",
      text: `You want to logout from ${imeiDriversUsers?.brand} ${imeiDriversUsers?.model} ${imeiDriversUsers?.deviceType}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, logout !",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logoutDriverDevice(auth?.accessToken, id));
      }
    });
  };

// const photourl="https://static0.gamerantimages.com/wordpress/wp-content/uploads/2025/06/inosuke-featured-image.jpg?w=1600&h=900&fit=crop"



  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Driver"), path: "/Driver", active: true },
        ]}
        title={t("Driver")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    {(driverPermissions?.filter) && (
                      <>
                        <div className="d-flex align-items-center">
                          <input
                            type="search"
                            placeholder="Search..."
                            className="form-control ms-1"
                            autoComplete="off"
                            value={search}
                            onChange={handleSearchChange}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                        {(driverPermissions?.add) && (
                          <>
                            <Link to="/Add-Driver">
                              <Button variant="success">
                                <i className="mdi mdi-clipboard-plus-outline me-1"></i>Add
                              </Button>
                            </Link>
                          </>
                        )}
                        {(driverPermissions?.print) && (
                          <>
                            <Button variant="dark">
                              <i className="mdi mdi-printer me-1"></i>Print
                            </Button>
                          </>
                        )}
                        {(driverPermissions?.excel) && (
                          <>
                            <Button variant="info">
                              <i className="mdi mdi-file-excel me-1"></i>Excel
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{ overflowY: 'auto', maxHeight: '500px', border: "1px solid #dee2e6" }}>
                <Table ref={tableRef} className="mb-0 table-bordered"
                  size="sm"
                  striped
                  responsive
                  id="table-to-print"
                  style={{ width: "100%", tableLayout: "auto" }}>
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>#</th>
                      <th>Vendor</th>
                      <th>Vehicle Number</th>
                      <th>Driver ID</th>
                      <th>Driver Name</th>
                      <th>Mobile Number</th>
                      <th>Driving License</th>
                      <th>State/City</th>
                      <th>Address</th>
                      <th>Device</th>
                      <th>Profile Picture</th>
                      <th>Status</th>
                      <th>Registered At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {driverLists.length === 0 ? (
                      <tr>
                        <td colSpan="11">No data found</td>
                      </tr>
                    ) : (<>
                      {driverLists?.map?.((item, index) => {
                        return (
                          <tr key={item.id}>
                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                            <td>{item?.vendor?.vendorName}</td>
                            <td>{item?.vehicle?.vehicleNumber}</td>
                            <td>{item?.driverId}</td>
                            <td>{item?.driverName}</td>
                            <td>{item?.mobileNumber}</td>
                            <td>{item?.dlNumber + ' / EXP -: ' + getDisplayDateTimeFormat(item?.dlExpiry)}</td>
                            <td>{item?.state?.stateName + ' ' + item?.city?.cityName}</td>
                            <td>{item?.address}</td>
                            <td>Version : {item?.appVersion}<br />{item?.brand} {item?.model} ({item?.mobileVersion})</td>
                            <td>
                              {item?.isRegistrationCompleted === Status.True && item?.photo != null ? (
                                <Badge
                                  className="bg-success px-1 py-1 rounded-pill text-uppercase fw-semibold"
                                  style={{ cursor: "pointer", fontSize: "0.55rem", letterSpacing: "0.4px" }}
                                  onClick={() => handleOpenPhotoModal(item?.photo)}
                                >
                                  Profile Picture
                                </Badge>
                              ) : (
                                <Badge
                                  className="bg-danger px-1 py-1 rounded-pill text-uppercase fw-semibold"
                                  style={{ cursor: "not-allowed", opacity: 0.7, fontSize: "0.55rem", letterSpacing: "0.4px" }}
                                >
                                  Upload Picture
                                </Badge>
                              )}
                            </td>

                            <td>{item?.status === Status.ACTIVE ? <Badge className={"bg-success"}>{item?.status}</Badge> : <><Badge className={"bg-danger"}>{item?.status}</Badge></>}</td>
                            <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                            <td>
                              {(driverPermissions?.edit) && (
                                <>
                                  {item?.status === Status.ACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-success" onClick={() => handleStatusChangeRequest(item, Status.INACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye"></i>
                                      </Link>
                                    </>
                                  )}
                                  {item?.status === Status.INACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-warning" onClick={() => handleStatusChangeRequest(item, Status.ACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye-off"></i>
                                      </Link>
                                    </>
                                  )}

                                  <Link to={`/Update-Driver/${item?.id}`} onClick={()=>{dispatch({type:"RESET_DELETE_DRIVER_STATUS"})}} className="action-icon text-info">
                                    <i className="mdi mdi-square-edit-outline"></i>
                                  </Link>
                                </>
                              )}

                              {item?.imei != null && (<>
                                <Link onClick={() => driverLogout(item?.id, item?.imeiDriversUsers)} className="action-icon text-warning">
                                  <i className="mdi mdi-logout"></i>
                                </Link>
                              </>)}

                            {
                              (driverPermissions?.edit && item?.isRegistrationCompleted === Status.False) && (
                                <>
                                  <Link to="#" className="action-icon text-primary" onClick={()=>handleOpenPhotoUploadModal(item?.id)}>
                                    <i className="mdi mdi-camera-plus"></i>
                                  </Link>
                                </>
                              )
                            }
                                  {(driverPermissions?.edit && item?.isRegistrationCompleted === Status.True) && (
                                <Link to="#" className="action-icon text-secondary" onClick={() => handleResetRegistrationRequest(item,Status.False)} title="Reset Registration (isRegistration = false)">
                                  <i className="mdi mdi-account-off-outline"></i>
                                </Link>
                              )}

                              {(driverPermissions?.delete) && (
                                <>
                                  <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)} >
                                    {" "}
                                    <i className="mdi mdi-delete"></i>
                                  </Link>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}</>
                    )}
                  </tbody>
                </Table>
              </div>
              <Modal show={showPhotoModal} onHide={handleClosePhotoModal} centered size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>Driver Picture</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center bg-dark">
                  {selectedPhotoUrl ? (
                    <img
                      src={`https://phed.s3.ap-south-1.amazonaws.com/driver-photos/${selectedPhotoUrl}`}
                      alt="Driver"
                      style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
                    />
                  ) : (
                    <p>No profile picture available.</p>
                  )}
                </Modal.Body>

              </Modal>
              <Modal show={showPhotoUploadModal} onHide={handleClosePhotoUploadModal} centered size="lg">
                <Modal.Header closeButton className="border-0 pb-0">
                  <Modal.Title className="w-100 text-center">
                    <span className="fw-semibold">Upload Driver Picture</span>
                    <div className="text-muted small mt-1">
                      High quality square image recommended (min 400x400)
                    </div>
                  </Modal.Title>
                </Modal.Header>
                
                <Modal.Body className="bg-light py-3">
                  <div className="d-flex justify-content-center">
                  
                    <div
                      className="bg-white shadow-sm rounded-3 p-3 w-100"
                      style={{ maxWidth: 380 }}
                    >
                      {pictureurl === null ? (
                        <>
                          <div
                            className="border border-2 border-dashed rounded-3 p-3 text-center"
                            style={{
                              borderStyle: "dashed",
                              cursor: "pointer",
                              transition: "all 0.2s ease-in-out",
                            }}
                            onClick={() => photoInputRef.current?.click()}
                          >
                            <div
                              className="rounded-circle bg-soft-primary d-inline-flex align-items-center justify-content-center mb-2"
                              style={{ width: 52, height: 52 }}
                            >
                              <i className="mdi mdi-camera-plus text-primary fs-4"></i>
                            </div>
                            <h6 className="mb-1">Click to choose a photo</h6>
                            <p className="text-muted small mb-0">
                              JPG, JPEG or PNG • Max 5 MB
                            </p>
                            <p className="text-muted small mb-0">
                              Clear face, front view, no blur
                            </p>
                          </div>
                          <input
                            type="file"
                            ref={photoInputRef}
                            className="d-none"
                            accept="image/*"
                            onChange={handlePhotoFileChange}
                          />
                        </>
                      ) : (
                        <div className="mt-2">
                          <label className="form-label mb-1 fw-semibold text-muted small">
                            Uploaded Photo
                          </label>
                          <div
                            className="border rounded-3 d-flex justify-content-center align-items-center bg-light"
                            style={{
                              padding: 8,
                              borderColor: "#d1d5db",
                            }}
                          >
                            <div
                              style={{
                                width: 120,
                                height: 120,
                                borderRadius: 8,
                                overflow: "hidden",
                                backgroundColor: "#e5e7eb",
                              }}
                            >
                              <img
                                src={pictureurl}
                                alt="Selected driver"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  display: "block",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      
                  <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="text-muted small">
                          * After selecting photo, click on `Upload`.
                        </div>


                        <div>
                          <Button
                            variant="primary"
                            className="px-4"
                            onClick={handlePhotoUploadClick}
                          >
                            Upload
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>

              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(driverCount / paginate)}</strong> </span>
                <RoundedPagination currentPage={page} totalPages={Math.ceil(driverCount / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingDriver && (<Preloader />)}
    </>
  );
};

export default Dashboard;
